import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, FormattedMessage } from 'react-intl';
import SimplePanel from '@/shared/components/SimplePanel';
import utils from '@/shared/utils/adminpulse';
import DataCacheService from '@/shared/services/DataCacheService';
import FormattedListValue from '@/shared/components/FormattedListValue';
import FormattedDateShort from '@/shared/components/FormattedDateShort';
import intlShape from '@/shared/utils/intlShape';
import messages from '../jobMessages';

// Job detail view for JobType.UpdateTaskParameterValue (7), used when the "wijzig hoofdtaakveld" /
// ChangeMainTaskField global action is used to bulk-update a dynamic task parameter instead of one of the
// fixed BatchTaskField values. The job-level parameters only carry the chosen value(s) and the
// ParameterDefinitionId (not its name/type), since that's tenant/task-template specific and resolving it here
// would require an extra lookup; this view therefore shows whichever value field was actually set.
const JobDetailChangeTaskParameterValue = ({ job, intl }) => {
  const parameters = utils.toCamel(job.parameters);
  if (!parameters) return null;

  return (
    <SimplePanel title={<FormattedListValue list="jobType" id={job.jobType} />}>
      <div className="info-block container-fluid radius4B">
        <div className="row">
          <div className="col-lg-12">
            <div className="row">
              <div className="col-md-2 col-sm-6">
                <label>
                  <b>
                    <FormattedMessage {...messages.Field} />
                  </b>
                </label>
              </div>
              <div className="col-md-10 col-sm-6">
                {parameters.parameterName}
              </div>
            </div>
            <div className="row">
              <div className="col-md-2 col-sm-6">
                <label>
                  <b>
                    <FormattedMessage {...messages.Value} />
                  </b>
                </label>
              </div>
              <div className="col-md-10 col-sm-6">
                {parameters.parameterValueDate && (
                  <FormattedDateShort value={parameters.parameterValueDate} />
                )}
                {!parameters.parameterValueDate &&
                  parameters.parameterValueNumeric !== null &&
                  parameters.parameterValueNumeric !== undefined &&
                  intl.formatNumber(parameters.parameterValueNumeric)}
                {!parameters.parameterValueDate &&
                  (parameters.parameterValueNumeric === null ||
                    parameters.parameterValueNumeric === undefined) &&
                  (DataCacheService.getUserName(parameters.parameterValueText) ||
                    parameters.parameterValueText)}
                {parameters.parameterValueBoolean !== undefined &&
                  parameters.parameterValueBoolean !== null &&
                  !parameters.parameterValueText &&
                  (parameters.parameterValueNumeric === null ||
                    parameters.parameterValueNumeric === undefined) &&
                  !parameters.parameterValueDate &&
                  (parameters.parameterValueBoolean ? 'true' : 'false')}
              </div>
            </div>
          </div>
        </div>
      </div>
    </SimplePanel>
  );
};

JobDetailChangeTaskParameterValue.propTypes = {
  job: PropTypes.shape({
    jobType: PropTypes.number,
    parameters: PropTypes.string,
  }).isRequired,
  intl: intlShape.isRequired,
};

export default injectIntl(JobDetailChangeTaskParameterValue);
